export const PROCESSING_FAILED_ERROR_CODE = 'lerror_73';
export const PAYMENT_FAILED_ERROR_CODE = 'lerror_75';
export const INVALID_CARD_ERROR = 'invalid_card';
export const IDRAM_FAILED = 'idram_failed';
export const ERROR_STATE_CONTRACT_CREATED = 'error_state_contract_created';
export const ERROR_STATE_VERIFIED = 'error_state_verified';

const ERROR_STATE_NOT_VERIFIED = 'error_state_not_verified';
const PAYMENT_NOT_VERIFIED_ERROR_CODE = 'lerror_72';

export const ERROR_STATES = {
  [PAYMENT_NOT_VERIFIED_ERROR_CODE]: {
    title: 'paymentConfirmation.contractFailText',
    description: 'backendErrors.lerror_72',
  },
  [PROCESSING_FAILED_ERROR_CODE]: {
    title: 'paymentConfirmation.contractSuccessText',
    description: 'backendErrors.lerror_73',
  },
  [PAYMENT_FAILED_ERROR_CODE]: {
    title: 'paymentConfirmation.contractFailText',
    description: 'backendErrors.lerror_75',
  },
  [ERROR_STATE_NOT_VERIFIED]: {
    title: 'paymentConfirmation.contractFailText',
    description: 'backendErrors.error_state_not_verified',
  },
  [INVALID_CARD_ERROR]: {
    title: 'paymentConfirmation.contractFailText',
    description: 'backendErrors.invalid_card',
  },
  [IDRAM_FAILED]: {
    title: 'paymentConfirmation.contractFailText',
    description: 'backendErrors.idram_failed',
  },
  [ERROR_STATE_CONTRACT_CREATED]: {
    title: 'paymentConfirmation.contractSuccessText',
    description: 'backendErrors.error_state_contract_created',
  },
  [ERROR_STATE_VERIFIED]: {
    title: 'paymentConfirmation.contractSuccessText',
    description: 'backendErrors.error_state_verified',
  },
  DEFAULT: {
    title: 'paymentConfirmation.contractFailText',
    description: 'backendErrors.lerror_72',
  },
};
